import { render } from "./AABoard.vue?vue&type=template&id=4c7a1f06"
import script from "./AABoard.vue?vue&type=script&lang=js"
export * from "./AABoard.vue?vue&type=script&lang=js"

import "./AABoard.vue?vue&type=style&index=0&id=4c7a1f06&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__